
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { Website, WebsiteDetails } from '@/services/Website/interfaces';
import WPCliRepositoryInterface, { WPCheckResultsInterface } from '@/services/WPCli/interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import InstallWPForm from '@/services/WPCli/forms/InstallWPForm';
import { DatabaseInterface, DatabaseRepositoryInterface, DatabaseStatus } from '@/services/Database/interfaces';
import { SystemUserInterface, SystemUserRepositoryInterface } from '@/services/SystemUsers/interfaces';

@Component({
  mixins: [Themeable],
  inject: [
    'wpCliRepository',
  ],
  sockets: {
    wpCheckResult(msg: { payload: WPCheckResultsInterface }): void {
      this.$emit('resultsReceived', msg.payload);
    },
  },
})
export default class WpUninstallDialog extends Vue {
  @Prop({ required: true }) public websiteId!: number;

  public visible: boolean = false;

  public loading: boolean = true;

  public readonly wpCliRepository!: WPCliRepositoryInterface;

  public installed: boolean = false;

  public async created(): Promise<void> {
    this.visible = true;
    this.$on('resultsReceived', this.handleWpCheckResults);

    try {
      await this.wpCliRepository.getWPStatus(this.websiteId);
    } catch (err) {
      const errMessage = err?.response?.data?.error || err.message;
      this.$errorDialog.show(`WP Installation Check Request Failed. . . ${errMessage}`);
    }
  }

  public handleWpCheckResults(data: WPCheckResultsInterface): void {
    if (Number(data.websiteId) !== this.websiteId) {
      return;
    }

    const wpInstalled = data.wordpressStatus;
    const otherInstallation = data.otherWebsiteStatus;

    this.installed = wpInstalled || otherInstallation;

    this.loading = false;
  }

  public async uninstall(): Promise<void> {
    try {
      await this.wpCliRepository.uninstallWp(this.websiteId);

      this.$successDialog.show('WP Uninstallation Started');
      this.destroyComponent();
    } catch (err) {
      const errMessage = err?.response?.data?.error || err.message;
      this.$errorDialog.show(`Uninstall WP Request Failed. . . ${errMessage}`);
    }
  }

  public getDirectory(
      websiteId: number,
      systemUserWebsiteId: number,
      systemUserDirectory: string,
      domain: string,
  ): string {
    const rootDirectory = (websiteId === systemUserWebsiteId ?
        systemUserDirectory : `${systemUserDirectory}/domains/${domain}`).replace(/\/\//gm, '/');

    return `${rootDirectory}/public_html`;
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
